var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{staticStyle:{"width":"12px","height":"14px","margin-right":"4px"},attrs:{"src":"https://img.kakaclo.com/web-img/index/Group%202174.png"}}),_vm._v(" "+_vm._s(_vm.$t('Index.Components.CarFlashTime.EndIn'))+" "+_vm._s(_vm.getEndTimeFormat)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }